import React from 'react';
import { useRouter } from '@sls-react/routing';
import { Message } from '@sls-react/design-system';

const PageMessage: React.FC = () => {
  const {
    query: { message, messageType },
  } = useRouter();

  if (!message) {
    return null;
  }

  return (
    <div className="container px-0 my-4">
      <Message
        info={messageType === 'info'}
        error={messageType === 'error'}
        success={messageType === 'success'}
        warning={!messageType || messageType === 'warning'}
      >
        {message}
      </Message>
    </div>
  );
};

export default PageMessage;
